
import React from 'react';
import { ShieldCheck, Key, LogOut } from 'lucide-react';
import { Card } from './SharedComponents';

export const SettingsSecurity = ({ isSuper }: { isSuper: boolean }) => (
  <Card className={`${isSuper ? 'bg-[#1e293b] border-white/5 p-10 text-white' : 'bg-white border-gray-100 p-10'} rounded-[40px] shadow-xl`}>
    <h3 className="text-2xl font-black uppercase tracking-tight mb-8">Segurança da Conta</h3>
    <div className="max-w-md space-y-6">
       <div className="space-y-1.5">
          <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest">Senha Atual</label>
          <input type="password" className={`w-full p-4 rounded-xl border outline-none font-bold ${isSuper ? 'bg-white/5 border-white/5 text-white' : 'bg-gray-50 border-gray-100 text-secondary'}`} placeholder="••••••••" />
       </div>
       <div className="space-y-1.5">
          <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest">Nova Senha</label>
          <input type="password" className={`w-full p-4 rounded-xl border outline-none font-bold ${isSuper ? 'bg-white/5 border-white/5 text-white' : 'bg-gray-50 border-gray-100 text-secondary'}`} placeholder="Mínimo 8 dígitos" />
       </div>
       <button className="w-full py-4 bg-primary text-white rounded-2xl font-black uppercase text-xs tracking-widest shadow-xl shadow-primary/20 hover:brightness-110 transition-all">Salvar Alterações</button>
    </div>
  </Card>
);
